// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ca349595f7769a8cb {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 10px;\r\n    background-color: #444444;\r\n}", "",{"version":3,"sources":["webpack://./src/Views/Solution/Apply.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".apply {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 10px;\r\n    background-color: #444444;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"apply": "ca349595f7769a8cb"
};
export default ___CSS_LOADER_EXPORT___;
